import React, { SVGProps } from 'react';

export const StudioRecordingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#a)">
      <path d="m17.51 7.13.04-.026v-.002l5.85-3.854V13.1a7.9 7.9 0 0 0-1.8-1.772V6.59l-3.04 2.004c-.824.611-1.09.854-1.147 1.312a8 8 0 0 0-2.421.282V9.8c-.014-6.084-.138-6.2-6.574-6.2-6.51 0-6.574.062-6.574 6.56s.063 6.559 6.574 6.559q.496 0 .944-.002a8 8 0 0 0-.02 1.797q-.443.005-.923.005c-7.512 0-8.375-.86-8.375-8.36S.907 1.8 8.42 1.8c6.62 0 8.077.728 8.326 5.934.24-.21.5-.406.765-.604" />
      <path d="M17.1 20.7a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
      <path d="M17.1 24a6.3 6.3 0 1 0 0-12.6 6.3 6.3 0 0 0 0 12.6m0-1.8a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
